import useGet from '@/core/composables/api/useGet'
import { onMounted } from 'vue'
import type { CoachSurvey } from './use-coach-survey'

export const useCoachSurveys = () => {
  const { data, load, status, reload } = useGet<CoachSurveyPreview[]>('coaching/surveys')
  onMounted(() => load())
  return {
    data,
    load,
    reload,
    status,
  }
}

export type CoachSurveyPreview = Omit<CoachSurvey, 'analysis'>
